import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { LiveOrdersData } from '../../models/LiveOrders';
import {
    liveOrderDetailsDialogAction,
    LiveOrderDetailsState,
} from '../../redux/slices/liveOrderDetailsDialogSlice';

const useLiveOrderDetailsDialog = () => {
    const state: LiveOrderDetailsState = useAppSelector(
        (state) => state.liveOrderDetailsDialog
    );
    const dispatch = useAppDispatch();

    const showDialog = useCallback((open: boolean, props: LiveOrdersData) => {
        if (open && props) {
            dispatch(liveOrderDetailsDialogAction.setDetailsDialog(props));
            dispatch(liveOrderDetailsDialogAction.setOpen(open));
        } else {
            dispatch(liveOrderDetailsDialogAction.setDetailsDialog(null));
            dispatch(liveOrderDetailsDialogAction.setOpen(open));
        }
    }, []);

    const closeDialog = () => {
        dispatch(liveOrderDetailsDialogAction.setOpen(false));
        dispatch(liveOrderDetailsDialogAction.setDetailsDialog(null));
    };

    return { ...state, showDialog, closeDialog };
};

export default useLiveOrderDetailsDialog;
